/* @flow */

import * as React from 'react';

import { selectTarget } from 'common/eventTargets';

export type Sorting = string;

type Props = {|
  value: ?Sorting,
  onValue: (?Sorting) => void
|};

export default function SearchSortSelect(props: Props) {
  const onChange = (e: Event) => {
    props.onValue(selectTarget(e).value);
  };

  return (
    <div className="m-search-order">
      <label>
        <strong>{__('search.search_results.sorting.heading')}:</strong>
        <select value={props.value} onChange={onChange}>
          <option value="">
            {__('search.search_results.sorting.default')}
          </option>
          <optgroup label={__('search.search_results.sorting.reviews.label')}>
            <option value="reviews">
              {__('search.search_results.sorting.reviews.desc')}
            </option>
          </optgroup>
          <optgroup label={__('search.search_results.sorting.price.label')}>
            <option value="price asc">
              {__('search.search_results.sorting.price.asc')}
            </option>
            <option value="price desc">
              {__('search.search_results.sorting.price.desc')}
            </option>
          </optgroup>
          <optgroup label={__('search.search_results.sorting.capacity.label')}>
            <option value="capacity asc">
              {__('search.search_results.sorting.capacity.asc')}
            </option>
            <option value="capacity desc">
              {__('search.search_results.sorting.capacity.desc')}
            </option>
          </optgroup>
        </select>
      </label>
    </div>
  );
}
